import React, { useEffect } from 'react'
import NotFoundSvg from "../assets/not_found.svg"
import { Link } from 'react-router-dom'

const NotFoundPage = () => {

  useEffect(() => {
    document.title = '404 - Admin Hi Nano';
  });

  return (
    <div className="flex items-center justify-center min-h-screen bg-slate-100">
      <div className="w-1/3 p-8 bg-white rounded-lg shadow">
        <div className="flex justify-center">
          <img src={NotFoundSvg} alt="Not Found Svg" className="w-2/3" />
        </div>
        <h1 className="my-3 text-3xl font-semibold">Oops...</h1>
        <p className="mb-5 text-lg text-slate-500">Halaman tidak tersedia.</p>
        <Link to="/" className="block p-3 text-center text-white bg-blue-600 rounded-lg shadow cursor-pointer hover:bg-blue-700 shadow-blue-100">
          Kembali ke Dasbor
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage